/*** IMPORTS FROM imports-loader ***/
var define = false;

export function stripLengthUnit(str) {
  const match = String(str).match(/^(-?[\d.]+)(.*)$/)
  if (match !== null) {
    // Value is something like 30px, 30%, 1.2rem
    return match[1]
  }
  return str ? str : ''
}

